<div class="container overlay-inside-container">
    <lib-app-icon
        icon="lock_icon"
        size="40x40"
        class="overlay-icon icon"/>
</div>